<template>
  <div class="order-item">
    <div class="d-flex mt-3">
      <div
        class="item-image"
        style="background-image: url(/images/icons/giftcert.png);"
      >
      </div>
      <div class="item-details pl-2 flex-grow-1">
        <div class="px-3">
          <strong>${{ value.amount || '?' }} Gift Certificate</strong>
          <!-- <div>Red - Medium</div> -->
          <div>To: {{ value.recipient || '?' }} {{ value.recipient_email ? '(' + value.recipient_email + ')' : '' }}</div>
          <div>From: {{ value.purchaser || '?' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item-status {
  opacity: 0.7;
  font-size: 20px;
  line-height: 20px;
}
.item-image {
  width: 100px;
  height: 100px;
  background-size: contain;
}
</style>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      default: null
    }
  },
  computed: {
    // Only allow returns for orders < 30 days ago
    canReturn () {
      return this.order &&
        this.order.date &&
        ((Date.now() / 1000) - this.order.date) < (3600 * 24 * 30)
    }
  }
}
</script>
